document.addEventListener("DOMContentLoaded", function () {
    const targetNode = document.querySelector("[js-main-product-form]");

    if (targetNode) {
        const config = { childList: true, subtree: true };

        const callback = function (mutationsList) {
            for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    if (node.classList.contains("sealsubs-target-element")) {
                        node.remove();
                    }
                    
                    const found = node.querySelector(".sealsubs-target-element");
                    if (found) {
                        found.remove();
                    }

                    // if(node.getAttribute("name") === "items[0][id]") {
                    //     document.querySelector("[js-master-variant-id]")?.remove();
                    // }
                }
                });
            }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

    const subcriptionInfoBtns = document.querySelectorAll("[js-subcription-info-btn]");
    const subcriptionInfoPopups = document.querySelectorAll("[js-subcription-info-popup]");

    if(subcriptionInfoBtns.length && subcriptionInfoPopups.length) {
        subcriptionInfoBtns.forEach(subcriptionInfoBtn => subcriptionInfoBtn.addEventListener('click', function() {
            const block = this.closest("[js-subcription-info]");

            subcriptionInfoPopups.forEach(subcriptionInfoPopup => {
                if(block.querySelector("[js-subcription-info-popup]") !== subcriptionInfoPopup) {
                    subcriptionInfoPopup.classList.remove("is-show")
                }
            });
            block.querySelector("[js-subcription-info-popup]")?.classList.toggle("is-show");
        }));

        document.addEventListener('click', function({ target }) {
            if(!target.closest("[js-subcription-info]")) {
                subcriptionInfoPopups.forEach(subcriptionInfoPopup => subcriptionInfoPopup.classList.remove("is-show"));
            }
        })
    }
});
